import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../components/base/base.component';
import { AuthService } from '../../../../services/auth.service';
import { EmployeePTO, PTOConfig } from '../../../../models/paid-time-off';
import { Person } from '../../../../models/person';
import { Observable, Subject } from 'rxjs';
import { ToastService } from '../../../../services/toast.service';
import { Select, Store } from '@ngxs/store';
import { PersonEditorState } from '../../../../state/PersonEditorState/PersonEditor.state';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import { map } from 'rxjs/operators';
import {
  RefreshPersonLists,
  TriggerSave
} from '../../../../state/PersonEditorState/PersonEditor.actions';

@Component({
  selector: 'app-benefits-tab',
  templateUrl: './benefits-tab.component.html',
  styleUrls: ['./benefits-tab.component.css'],
  standalone: false
})
export class BenefitsTabComponent extends BaseComponent implements OnInit {
  @Select(PersonEditorState.getEmployeePTOs) ptos: Observable<EmployeePTO[]>;
  @Select(PersonEditorState.getPTOConfigs) ptoConfigs: Observable<PTOConfig[]>;
  @Select(PersonEditorState.getPerson) person: Observable<Person>;
  @Select(PersonEditorState.getReadOnly) readOnly: Observable<boolean>;

  @Output()
  refreshLists = new EventEmitter();
  @Output()
  triggerSave = new EventEmitter<Subject<void>>();
  carryOverRules: string[];
  clientCode: string;
  editingPTO: boolean;
  selPTO: EmployeePTO = null;

  showPtoModal = false;

  constructor(
    public authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private store: Store
  ) {
    super();
  }

  modalClosed() {
    this.showPtoModal = false;
    this.selPTO = null;
    this.store.dispatch(new RefreshPersonLists());
  }

  addPTO() {
    this.showPtoModal = true;
    this.editingPTO = false;
  }

  editPTO(pto: EmployeePTO) {
    this.selPTO = pto;
    this.showPtoModal = true;
  }

  getPTOConfig(id: number): Observable<PTOConfig> {
    return this.store.selectOnce(PersonEditorState.getPtoConfig(id));
  }

  ngOnInit() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(clientCode => {
      this.clientCode = clientCode;
      this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
        if (person.Id == null) {
          console.log('hit');
          this.store
            .dispatch(
              new TriggerSave(
                clientCode,
                {
                  1: 'personal-details-tab',
                  2: 'job-details-tab',
                  3: 'earnings-and-deductions-tab',
                  4: 'taxes-tab',
                  5: 'benefits-tab',
                  6: 'direct-deposit-tab',
                  7: 'audit-log-tab'
                },
                'benefits-tab'
              )
            )
            .subscribe(() => {
              this.store.dispatch(new RefreshPersonLists()).subscribe(() => {});
            });
        } else {
          this.store.dispatch(new RefreshPersonLists()).subscribe(() => {});
        }
      });
    });
  }
}
